import { Role } from '@okletsplay/core';
import { Route } from 'app/enums';
import { GuardedRoute } from 'app/interfaces/route';
import { rolesGuard } from 'app/routing/guards';
import { lazyRetry } from 'app/utils';

const ManageTournamentsPage = lazyRetry(() => import('modules/admin/pages/ManageTournamentsPage'));
const ManageUsersPage = lazyRetry(
  () => import('modules/admin/pages/ManageUsersPage/ManageUsersPage')
);
const ManageUserPage = lazyRetry(() => import('modules/admin/pages/ManageUserPage/ManageUserPage'));
const ManageWithdrawPage = lazyRetry(
  () => import('modules/admin/pages/ManageWithdrawPage/ManageWithdrawPage')
);

export const AdminRoutes: GuardedRoute[] = [
  {
    path: Route.AdminManageTournaments,
    name: 'Manage Tournament by Admin',
    component: ManageTournamentsPage,
    availability: [Role.TournamentAdministrator],
    guards: [rolesGuard([Role.TournamentAdministrator])],
  },
  {
    path: Route.AdminManageUsers,
    name: 'Manage User',
    component: ManageUsersPage,
    availability: [Role.User, Role.UserAdministrator],
    guards: [rolesGuard([Role.User, Role.UserAdministrator])],
  },
  {
    path: Route.AdminManageUser,
    name: 'Manage User',
    component: ManageUserPage,
    availability: [Role.User, Role.UserAdministrator],
    guards: [rolesGuard([Role.User, Role.UserAdministrator])],
  },
  {
    path: Route.AdminWithdrawRequests,
    name: 'Withdraw Requests',
    component: ManageWithdrawPage,
    availability: [Role.User, Role.PaymentAdministrator],
    guards: [rolesGuard([Role.User, Role.PaymentAdministrator])],
  },
];
